<template>
    <div class="content">
		<Header></Header>
		<div class="home-page">
      <div class="nav">
      	<span class="">{{$t('profile')}}</span>
      </div>
			<div class="information mt20">
        <div class="personal-info mt20" style="text-align: center">
          <div :class="{'vip-img':info.is_vip}">
            <div class="account-img">
              <input class="upload-image" type="file" @change="handleFileUpload" accept="image/*">
              <img :src="info.avatar">
            </div>
          </div>

            <div class="input-div">
              <div class="span fs33 fw7">- {{$t('Name')}} -</div>
              <div class="input-item">
                <input readonly class="input" v-model="info.nickname" placeholder="">
              </div>
            </div>
<!--            <div class="input-div">-->
<!--              <div class="span fs33 fw7">- {{$t('phoneNumber')}} -</div>-->
<!--              <div class="input-item">-->
<!--                <input disabled class="input" v-model="info.mobile" placeholder="">-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="input-div">-->
<!--              <div class="span fs33 fw7">- {{$t('address')}} -</div>-->
<!--              <div class="input-item">-->
<!--                <input class="input" v-model="info.address" placeholder="">-->
<!--              </div>-->
<!--            </div>-->
            <div class="ac mt50">
<!--              <button class="btn1 btn-blue info-button" @click="getSubmit">{{$t('Save')}}</button>-->
              <button class="btn2 mt50 " @click="unSubscribe('unSubscribe')">{{$t('UNSUBSCRIBE')}}</button>
            </div>
        </div>
			</div>
		</div>
    <Dialog ref="saveDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
        <div class="alert-modal sub-bg" slot="mdBox" >
            <div class="sub-content ac">
              <div class="nav">
                <span class="font-family">{{$t('ohNo')}}!</span>
              </div>
              <div class="sub-bottom">
                  <div class="sub-t fs33">
                    {{$t('subDes2')}}
                  </div>
                  <div class="sub-t fs20 fw4">
                    {{$t('des2')}}
                  </div>
                  <div class="mt50 disflex" style="justify-content: space-evenly;">
                    <button class="btn-bl fw7" @click="saveModal()">{{$t('Yes')}}</button>
                    <div class="">
                      <button class="btn-yl fw7" @click="closeSubscribe('unSubscribe')">{{$t('No')}}</button>
                    </div>
                  </div>
              </div>
            </div>
        </div>
    </Dialog>
	</div>
</template>
<script>
import Header from '../components/header'
import Dialog from '../components/dialog'

export default {
    components:{
		Header,
    Dialog
    },
    data() {
        return {
          disAbled:'',
          edit:'Edit',
          isEdit:false,
          nickname:'',
          info:{
            'nickname':'',

          }

        }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.edit = this.$t('Edit')
		this.getHome();

	},
    methods: {
      back(){
        this.$router.go(-1);
      },
    getSubmit(){
    	let that = this;
      let data = {
        'nickname':that.info.nickname,
         'address':that.info.address
      }
      that.$parent.loadModal(true);
    	that.$api.post('/api/user/profile',data,r =>{
    		that.$parent.returnCode(r,function(){
    			that.getHome()
    	    that.isEdit = false;
    			that.$parent.loadModal(false);
          that.$router.go(-1);
    		});
    	})
    },
		getHome(){
			let that =this;
      this.$parent.loadModal(true);
			that.$api.post('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
					that.$parent.loadModal(false);
        });

			})
		},

    unSubscribe(){
    	//this.isShow = false;
    	this.$refs.saveDialog.showMaskFun();
    },
    closeSubscribe(){
      this.$refs.saveDialog.closeMask();
    },
      handleFileUpload(event) {
        let that = this;
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            console.log(e);
            this.base64Image = e.target.result;

            // 从Base64字符串中提取图片类型
            const matches = this.base64Image.match(/^data:image\/([A-Za-z-+/]+);base64,/);
            const type = matches ? matches[1] : '';

            that.uploadImage(type);
          };
          reader.readAsDataURL(file);
        }
      },

      async uploadImage(imageType) {
        let that = this
        if (!this.base64Image) {
          alert('请先选择图片');
          return;
        }
        try {
          let data = {
            image: {
              "content": this.base64Image,
              "type": imageType || "" // 使用提取的类型，如果没有则留空
            }
          }
          that.$parent.loadModal(true);
          that.$api.post('/api/user/upload_avatar', data, r => {
            that.$parent.returnCode(r, function () {
              that.$parent.loadModal(false);
              if(r.code == 1){
                that.getHome()
              }else {
                that.$utils.alertText(that.$t('upload_fail'),80)
              }
            })

          })
        } catch (error) {
          console.error('上传失败', error);
        }
      },
    // 弹框保存
    saveModal (){
      let that =this;
      that.$parent.loadModal(true);
      that.$api.post('/api/user/unsubscribe',null,r =>{
          that.$utils.alertText(r.msg,80,3000);
          // that.$parent.loadModal(false);
          if(r.code==1){
            // localStorage.removeItem('token')
            // localStorage.removeItem('mobile')
            // this.$router.push({path:'/login',query:{}});
            window.location.href = r.data.url
          }else{
            this.$refs.saveDialog.closeMask();
          }
        //});
      })
    }
	}
}
</script>
<style>
  .info-button{}
  .info-button img{margin-right: 10px;}
</style>



// WEBPACK FOOTER //
// src/page/personalInfo.vue